module.exports = __webpack_public_path__ + "static/media/riley-win.ae6f2f86.jpg";